import React, { useContext } from 'react'
import noteContext from "../context/notes/noteContext"

const NoteItem = (props) => {
    const context = useContext(noteContext)
    const { deleteNote } = context;
    const { note, updateNote } = props
    return (
        <div className="col-md-4 col-lg-3 my-2">
            <div className="card my-3 h-100">
                <div className="card-body">
                    <div className="d-flex">
                        <h5 className="card-title">{note.title}</h5>
                        <i className="fa-solid fa-trash-can mx-2 justify-content-right"
                            onClick={() => {
                                deleteNote(note._id);
                                props.showAlert("Deleted successfully", "success");
                            }}></i>
                        <i className="fa-regular fa-pen-to-square mx-2 align-items-right" onClick={() => { updateNote(note) }}></i>
                    </div>
                    <p className="card-text">{note.description}</p>
                    <span className="badge bg-info text-dark">{note.tag}</span>
                </div>
            </div>
        </div>
    )
}

export default NoteItem